// Note and key names shared by Beat, Drums, Dig and Chord match. Plain data, no logic imports (so it stays in the initial bundle).
export const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'] as const;

/** "F minor" or "F major". */
export function keyName(root: number, minor: boolean): string {
  return `${NOTE_NAMES[((root % 12) + 12) % 12]} ${minor ? 'minor' : 'major'}`;
}
